import React from 'react';

class DisplayAttr extends React.Component {
  constructor(props){
    super(props);
  } 
  
  render(){
    const {title, value} = this.props;
    return (
      <div style={{display:'inline-flex', flexDirection:'row'}}>
        <h6 style={{marginTop:'6px', marginBottom:'6px'}}> 
          {title}:
        </h6>
        <div  style={{marginLeft:'6px', alignSelf:'center'}}>
          {value}
        </div>
      </div>
      );
  }
}

export default DisplayAttr;
